import { Container } from 'reactstrap'
import InvalidQR from '../../assets/images/InvalidQR.png'
import './Error.scss'

const InvalidCodeError = () => {
  return (
    <Container className='InvalidCodeError'>
      <div className='InvalidCodeError__Content'>
        <div>
          <img src={InvalidQR} className='InvalidCodeError__Content__Icon' />
        </div>
        <span className='InvalidCodeError__Content__Header'>Invalid Code</span>
        <div className='InvalidCodeError__Content__Text'>
          Looks like you have scanned an invalid QR code
        </div>
      </div>
    </Container>
  )
}

export default InvalidCodeError
